import React, { useState, useMemo, useEffect } from "react";
import {
  Container,
  RetirementField,
  RetirementCard,
  RetirementItem,
  EmptyMessage,
  Pagination,
  BtnPagination,
  BtnClose,
  BtnNav,
  Title,
  TitleField,
  ValueField
} from "./styles";

const ShowRetirements = ({ retirementProjects, onClose }) => {
  const [page, setPage] = useState(0);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const itemsPerPage = 1;

  const retirements = useMemo(() =>
    retirementProjects?.flatMap((p) => p?.retirements || []) || [],
    [retirementProjects]
  );

  const filteredRetirements = useMemo(() => {
    return retirements.filter((r) => {
      if (!r?.date) return true;
      const d = new Date(r.date);
      const start = startDate ? new Date(startDate) : null;
      const end = endDate ? new Date(endDate) : null;

      if (start && d < start) return false;
      if (end && d > end) return false;
      return true;
    });
  }, [retirements, startDate, endDate]);

  const totalPages = Math.ceil(filteredRetirements.length / itemsPerPage);
  const currentItems = filteredRetirements.slice(
    page * itemsPerPage,
    (page + 1) * itemsPerPage
  );

  const allowedFields = [
    'asset_name',
    'asset_type',
    'notes',
    'project_type',
    'quantity',
    'standard',
    'txid',
    'vintage'
  ];

  // Fechar popup ao pressionar ESC
  useEffect(() => {
    const handleEsc = (event) => {
      if (event.keyCode === 27) {
        onClose();
      }
    };
    document.addEventListener('keydown', handleEsc);
    
    // Prevenir scroll do body quando o modal está aberto
    document.body.style.overflow = 'hidden';

    return () => {
      document.removeEventListener('keydown', handleEsc);
      document.body.style.overflow = 'unset';
    };
  }, [onClose]);

  // Fechar ao clicar no overlay (fora do card)
  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  if (!retirementProjects) {
    return (
      <Container onClick={handleOverlayClick}>
        <RetirementCard>
          <BtnClose onClick={onClose}>✖</BtnClose>
          <Title>Detalhes das Aposentadorias</Title>
          <EmptyMessage>Carregando dados...</EmptyMessage>
        </RetirementCard>
      </Container>
    );
  }

  return (
    <Container onClick={handleOverlayClick}>
      <RetirementCard>
        <BtnClose onClick={onClose}>✖</BtnClose>
        <Title>Detalhes das Aposentadorias</Title>

        {retirements.length === 0 ? (
          <EmptyMessage>Nenhuma aposentadoria encontrada.</EmptyMessage>
        ) : currentItems.length > 0 ? (
          currentItems.map((retirement) => (
            <RetirementItem key={retirement.id || Math.random()}>
              {Object.entries(retirement)
                .filter(([key]) => allowedFields.includes(key))
                .map(([key, value]) => (
                  <RetirementField key={key}>
                    <TitleField>{key}:</TitleField>
                    <ValueField>{String(value)}</ValueField>
                  </RetirementField>
                ))}
            </RetirementItem>
          ))
        ) : (
          <EmptyMessage>Nenhuma aposentadoria encontrada para o período.</EmptyMessage>
        )}

        {totalPages > 1 && (
          <Pagination>
            <BtnNav disabled={page === 0} onClick={() => setPage((p) => p - 1)}>
              {"<"}
            </BtnNav>

            {Array.from({ length: Math.min(3, totalPages) }).map((_, idx) => {
              const start = Math.floor(page / 3) * 3;
              const pageNumber = start + idx;

              if (pageNumber >= totalPages) return null;

              return (
                <BtnPagination
                  key={pageNumber}
                  onClick={() => setPage(pageNumber)}
                  active={page === pageNumber}
                >
                  {pageNumber + 1}
                </BtnPagination>
              );
            })}

            <BtnNav disabled={page === totalPages - 1} onClick={() => setPage((p) => p + 1)}>
              {">"}
            </BtnNav>
          </Pagination>
        )}
      </RetirementCard>
    </Container>
  );
};

export default ShowRetirements;